import createHttp from '@/config/http';
import type { CreateDenialSupportPayload, DenialSupportDetailsResponse, DenialSupportProductsResponse, DenialSupportRaw } from '@/types/denialSupport';
import type { ResponseMetaData } from '@/types/service';

const http = createHttp(
	import.meta.env.VITE_CASES_URL || 'http://localhost:3007',
);

export const getAllDenialSupports = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	status = '',
	globalFilters = '[]',
	sort = '',
): Promise<{
	items: DenialSupportRaw[];
	meta: ResponseMetaData;
}> => {
	const params = {
		page: String(page),
		limit: String(limit),
		columnsFilters,
		search,
		status: String(status),
		globalFilters,
		sort,
	};

	const response = await http.get('/denial-support', { params });

	return {
		items: response.data.data.items || [],
		meta: response.data.data.metaData || {},
	};
};

export const getSingleDenialSupport = async (id: string): Promise<DenialSupportDetailsResponse> => {
	const response = await http.get(`/denial-support/${id}`);
	return response.data.data;
};

export const createDenialSupport = async (
	dsData: CreateDenialSupportPayload,
): Promise<any> => {
	const response = await http.post('/denial-support', dsData);
	return response.data.data;
};

export const getDenialSupportProducts = async (): Promise<DenialSupportProductsResponse> => {
	const response = await http.get('/denial-support/products');
	return response.data.data;
};